export const formatDateForMonthYear = (timestamp) => {
  const date = new Date(timestamp * 1); // Multiplica por 1 para converter para milissegundos;
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Adiciona 1 porque o método getMonth() retorna um valor de 0 a 11;
  return `${month}/${year}`;
};